export const APP_VERSION = "1767853285403";